import React from "react";
import personne from "../../images/icons/1.png";
import mairies from "../../images/icons/2.png";
import usine from "../../images/icons/3.png";

export interface StatisticHomeSectionProps {
  headingTitle?: string;
  className?: string;
  img1?: string;
  img2?: string;
  img3?: string;
  img4?: string;
  img5?: string;
  title1?: string;
  title2?: string;
  title3?: string;
  title4?: string;
  title5?: string;
  val1?: string;
  val2?: string;
  val3?: string;
  val4?: string;
  val5?: string;
}

const IconsList2: React.FC<StatisticHomeSectionProps> = ({
  className,
  headingTitle = "Ce que comprend la visite ?",
  img1 = personne,
  img2 = mairies,
  img3 = usine,
  img4 = usine,
  img5 = usine,
  title1 = "Transport",
  title2 = "Animation",
  title3 = "Groupe de 30",
  title4 = "Groupe de 30",
  title5 = "Groupe de 30",

  val1 = "Organisation du transport aller-retour depuis votre établissement jusqu’à notre espace pédagogique.",
  val2 = "Conférenciers spécialisés et activités adaptées au niveau scolaire des élèves (CP à CM2).",
  val3 = "Organisation du transport aller-retour depuis votre établissement jusqu’à notre espace pédagogique.",
  val4 = "Organisation du transport aller-retour depuis votre établissement jusqu’à notre espace pédagogique.",
  val5 = "Organisation du transport aller-retour depuis votre établissement jusqu’à notre espace pédagogique.",
}) => {
  const stats = [
    { img: img1, title: title1, val: val1 },
    { img: img2, title: title2, val: val2 },
    { img: img3, title: title3, val: val3 },
    { img: img4, title: title4, val: val4 },
     
  ];

  return (
    <div
      className={`relative p-12 bg-[#1699761A] ${className}`}
      style={{ zIndex: 0 }}
    >
      <div className="mb-10 text-xl font-bold text-center text-black">
        {headingTitle}
      </div>

      {/* Container for the stats items */}
      <div className="flex flex-wrap justify-center gap-10 mb-10 xl:gap-0 xl:flex-nowrap ">
        {stats.map((item, index) => (
          <div
            key={index}
            className={`flex flex-col items-center text-center   px-4  `}
          >
            <div
              className="w-20 h-20 mx-auto mb-4 bg-primary"
              style={{
                mask: `url(${item.img}) no-repeat center`,
                maskSize: "contain",
                WebkitMask: `url(${item.img}) no-repeat center`,
                WebkitMaskSize: "contain",
              }}
            />
            <div className="mb-2 text-lg font-bold text-black whitespace-nowrap">
              {item.title}
            </div>
            <div className="text-sm font-bold text-primary">{item.val}</div>
          </div>
        ))}
      </div>
         <div className="flex flex-wrap justify-center gap-10 mb-10 xl:gap-0 xl:flex-nowrap ">
        <div
          className={`flex flex-col items-center text-center max-w-[254px] px-4  `}
        >
          <div
            className="w-20 h-20 mx-auto mb-4 bg-primary"
            style={{
              mask: `url(${img5}) no-repeat center`,
              maskSize: "contain",
              WebkitMask: `url(${img5}) no-repeat center`,
              WebkitMaskSize: "contain",
            }}
          />
          <div className="mb-2 text-lg font-bold text-black">{title5}</div>
          <div className="text-sm font-bold text-primary">{val5}</div>
        </div>
      </div>
    </div>
  );
};

export default IconsList2;
